import React from "react";
import axios from "axios";
import * as Icon from "react-feather";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { getAuthHeaders } from "../../../utils/adminAuth";

import "./Coupons.css";

const Coupons = (props) => {
  const history = useHistory();
  const url = process.env.REACT_APP_BASEURL;
  const { t } = useTranslation('common');
  const [couponsData, setcouponsData] = React.useState(null);
  const [filteredData, setFilteredData] = React.useState(null);
  const [msgData, setMsgData] = React.useState(null);
  const [school, setSchool] = React.useState({});
  const [filterStatus, setFilterStatus] = React.useState("all");
  const [dateRange, setDateRange] = React.useState({ start: "", end: "" });
  const [statistics, setStatistics] = React.useState({
    total: 0,
    sent: 0,
    redeemed: 0,
    pending: 0,
  });
  const [campaigns, setCampaigns] = React.useState([]);
  const [selectedCampaignFilter, setSelectedCampaignFilter] = React.useState("all");
  const [campaignMeta, setCampaignMeta] = React.useState({ id: null, name: null });
  const [availableCoupons, setAvailableCoupons] = React.useState([]);
  const [selectedCouponCode, setSelectedCouponCode] = React.useState("");
  // Pagination
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [showFilters, setShowFilters] = React.useState(false);

  React.useEffect(() => {
    const tkn = window.sessionStorage.getItem("Token");
    const usr = window.sessionStorage.getItem("User");
    if (!tkn || !usr) {
      history.push("/");
    }
  }, []);
  React.useEffect(() => {
    document.getElementsByClassName("alert")[0]?.classList.add("show");
    // Read campaign from URL and preselect filter if present
    const params = new URLSearchParams(window.location.search);
    const campaignFromUrl = params.get('campaign') || params.get('campaignId');
    const campaignNameFromUrl = params.get('campaignName');
    if (campaignFromUrl && campaignFromUrl !== 'undefined') {
      setSelectedCampaignFilter(campaignFromUrl);
      setCampaignMeta({ id: campaignFromUrl, name: campaignNameFromUrl || null });
    }
    
    // Load coupons
    // ✅ NUEVO: Pasar campaignId como query parameter si existe
    const couponUrl = campaignFromUrl && campaignFromUrl !== 'undefined'
      ? `${url}/api/admin/get-coupon-user?campaignId=${campaignFromUrl}`
      : `${url}/api/admin/get-coupon-user`;
    
    axios
      .get(couponUrl, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        const data = res.data.result || null;
        setcouponsData(data);
        setFilteredData(data);
        calculateStatistics(data);
      })
      .catch((err) => {
        console.log(err, err.response);
        if (err?.response?.status === 401) {
          sessionStorage.clear();
          history.push("/");
          return;
        }
        setMsgData(
          {
            message: err?.response?.data.message,
            type: err?.response?.status,
          } || null
        );
      });

    // Load campaigns
    axios
      .get(`${url}/api/coupon-campaign/list`, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        const list = res.data?.data || res.data?.result || [];
        // Normalizar shape - incluir couponPrefix para usar en exportación
        const normalized = list.map((c) => ({
          id: c.campaignId || c.id,
          name: c.campaignName || c.name,
          couponPrefix: c.couponPrefix || c.campaignCode || null,
        }));
        setCampaigns(normalized);
      })
      .catch((err) => {
        console.log("Error loading campaigns:", err);
      });

    // Load available coupons (not assigned)
    axios
      .get(`${url}/api/coupon-campaign/available-coupons`, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        setAvailableCoupons(res.data.result || []);
      })
      .catch((err) => {
        console.log("Error loading available coupons:", err);
      });

    // Closing the alert
    setTimeout(() => {
      document.getElementsByClassName("alert")[0]?.classList.remove("show");
    }, 5000);
  }, []);

  const sendCoupon = (email, userName) => {
    email
      ? axios
          .post(
            `${url}/api/admin/send-coupon-code`,
            {
              Email: email,
              UserName: userName,
            },
            {
              headers: getAuthHeaders(),
            }
          )
          .then((res) => {
            setMsgData(
              { message: res.data.message, type: res.data.status } || null
            );
            document.getElementById("close").click();
          })
          .catch((err) => {
            console.log(err, err.response);
            if (err?.response?.status === 401) {
              sessionStorage.clear();
              history.push("/");
              return;
            }
            setMsgData(
              {
                message: err.response?.data?.message,
                type: err.response?.status,
              } || null
            );
            document.getElementById("close").click();
          })
      : console.log("No Email Found!");
  };

  const calculateStatistics = (data) => {
    if (!data) return;
    const stats = {
      total: data.length,
      sent: data.filter((item) => item.Coupon).length,
      redeemed: data.filter((item) => item.redeem).length,
      pending: data.filter((item) => !item.Coupon).length,
    };
    setStatistics(stats);
  };

  const applyFilters = () => {
    if (!couponsData) return;

    let filtered = [...couponsData];

    // Filter by campaign
    if (selectedCampaignFilter !== "all") {
      filtered = filtered.filter(
        (item) => String(item.campaignId || '') === String(selectedCampaignFilter)
      );
    }

    // Filter by status
    if (filterStatus === "sent") {
      filtered = filtered.filter((item) => item.Coupon && !item.redeem);
    } else if (filterStatus === "redeemed") {
      filtered = filtered.filter((item) => item.redeem);
    } else if (filterStatus === "pending") {
      filtered = filtered.filter((item) => !item.Coupon);
    }

    // Filter by date range
    if (dateRange.start) {
      filtered = filtered.filter(
        (item) => new Date(item.createdAt) >= new Date(dateRange.start)
      );
    }
    if (dateRange.end) {
      filtered = filtered.filter(
        (item) => new Date(item.createdAt) <= new Date(dateRange.end)
      );
    }

    setFilteredData(filtered);
  };

  React.useEffect(() => {
    applyFilters();
  }, [filterStatus, dateRange, selectedCampaignFilter, couponsData]);

  // Update campaignMeta when selectedCampaignFilter changes
  React.useEffect(() => {
    if (selectedCampaignFilter === "all") {
      setCampaignMeta({ id: null, name: null });
    } else {
      // Find the campaign in the campaigns array
      const campaign = campaigns.find(c => String(c.id) === String(selectedCampaignFilter));
      if (campaign) {
        setCampaignMeta({ id: campaign.id, name: campaign.name });
      } else {
        // If not found in campaigns array but filter is set, keep the ID and clear random name
        setCampaignMeta({ id: selectedCampaignFilter, name: null });
      }
    }
  }, [selectedCampaignFilter, campaigns]);

  const exportToCSV = () => {
    if (!filteredData || filteredData.length === 0) {
      setMsgData({
        message: t('coupons.messages.noDataExport'),
        type: "Error",
      });
      return;
    }

    const headers = [
      t('coupons.csv.headers.index'),
      t('coupons.csv.headers.creationDate'),
      t('coupons.csv.headers.schoolName'),
      t('coupons.csv.headers.schoolAddress'),
      t('coupons.csv.headers.schoolPhone'),
      t('coupons.csv.headers.userName'),
      t('coupons.csv.headers.email'),
      t('coupons.csv.headers.coupon'),
      t('coupons.csv.headers.status'),
      t('coupons.csv.headers.activationDate'),
      t('coupons.csv.headers.provider'),
    ];

    const csvData = filteredData.map((item, index) => [
      index + 1,
      new Date(item.createdAt).toLocaleDateString(),
      item.SchoolName,
      item.SchoolAddress,
      item.OfficePhone,
      item.UserName,
      item.Email,
      item.Coupon || t('coupons.csv.na'),
      item.redeem ? t('coupons.csv.status.redeemed') : item.Coupon ? t('coupons.csv.status.sent') : t('coupons.csv.status.pending'),
      item.activatedAt ? new Date(item.activatedAt).toLocaleDateString() : t('coupons.csv.na'),
      item.Provider || t('coupons.csv.na'),
    ]);

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) =>
        row.map((cell) => `"${cell}"`).join(",")
      ),
    ].join("\n");

    // Determinar el nombre del archivo según si hay un filtro de campaña activo
    let fileName = `${t('coupons.csv.fileName.base')}_${new Date().toISOString().split("T")[0]}.csv`;
    
    // Si hay una campaña seleccionada (no es "all"), usar el prefijo de la campaña
    if (selectedCampaignFilter !== "all") {
      const selectedCampaign = campaigns.find(c => String(c.id) === String(selectedCampaignFilter));
      if (selectedCampaign && selectedCampaign.couponPrefix) {
        // Usar el prefijo de la campaña para el nombre del archivo
        const prefix = selectedCampaign.couponPrefix.trim().toUpperCase();
        fileName = `${prefix}_${new Date().toISOString().split("T")[0]}.csv`;
      }
    }

    const blob = new Blob(["\uFEFF" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setMsgData({
      message: t('coupons.messages.exportedSuccess'),
      type: "Success",
    });
  };

  const showMessage = () => {
    return (
      <div
        className={
          msgData.type === "Success"
            ? "alert alert-success fixed-bottom alert-dismissible fade show"
            : "alert alert-danger fixed-bottom alert-dismissible fade show"
        }
        role="alert"
        style={{ zIndex: "9999" }}
      >
        {msgData.message}
        <button
          type="button"
          className="close"
          // data-dismiss="alert"
          // aria-label="Close"
          onClick={() =>
            document
              .getElementsByClassName("alert")[0]
              ?.classList.remove("show")
          }
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  };

  const addCouponHandler = (e) => {
    e.preventDefault();

    // Crear cupón tradicional (sin campaña)
    axios
      .post(
        `${url}/api/admin/post-coupon-user`,
        {
          Email: document.getElementById("school-email").value,
          SchoolName: document.getElementById("school-name").value,
          UserName: document.getElementById("user-name").value,
          SchoolAddress: document.getElementById("school-address").value,
          OfficePhone: document.getElementById("school-phone").value,
          Provider: document.getElementById("provider").value,
        },
        {
          headers: getAuthHeaders(),
        }
      )
      .then((res) => {
        setMsgData(
          {
            message: res.data?.message || "Cupón creado exitosamente",
            type: res.data?.status || "Success",
          } || null
        );
        document.getElementById("close-modal").click();
        document.getElementById("school-email").value = "";
        document.getElementById("school-name").value = "";
        document.getElementById("user-name").value = "";
        document.getElementById("school-address").value = "";
        document.getElementById("school-phone").value = "";
        // Reload data
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        setMsgData(
          { message: err.response?.data?.message || 'Error creando cupón', type: err.response?.status || 'Error' } ||
            null
        );
      });
  };

  // Derived pagination data
  const totalItems = filteredData ? filteredData.length : 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const displayedData = filteredData ? filteredData.slice(startIndex, endIndex) : [];

  return (
    <>
      <div className="mx-4" style={{ marginTop: "0px" }}>
        {msgData ? showMessage() : null}
        <div className="d-flex justify-content-between align-items-center py-2">
          <h5 className="section-title">{t('coupons.pageTitle')}</h5>
        </div>
        {/* Botón para ir a Campañas */}
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn"
            style={{
              backgroundColor: '#6264A7', // MS Teams violet
              color: 'white',
              fontWeight: 600,
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onClick={() => history.push('/campaigns')}
          >
            <Icon.Flag size={16} className="mr-2" />
            {t('coupons.goToCampaigns')}
          </button>
        </div>
        
        {/* Statistics Cards */}
        <div className="row mb-3">
          <div className="col-md-3">
            <div className="card stat-card stat-card-total p-2">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-1">{t('coupons.stats.total')}</h6>
                    <h2 className="mb-0">{statistics.total}</h2>
                  </div>
                  <Icon.ShoppingBag size={28} className="text-primary" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stat-card stat-card-sent p-2">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-1">{t('coupons.stats.sent')}</h6>
                    <h2 className="mb-0">{statistics.sent}</h2>
                  </div>
                  <Icon.Send size={28} className="text-info" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stat-card stat-card-redeemed p-2">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-1">{t('coupons.stats.redeemed')}</h6>
                    <h2 className="mb-0">{statistics.redeemed}</h2>
                  </div>
                  <Icon.CheckCircle size={28} className="text-success" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stat-card stat-card-pending p-2">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-1">{t('coupons.stats.pending')}</h6>
                    <h2 className="mb-0">{statistics.pending}</h2>
                  </div>
                  <Icon.Clock size={28} className="text-warning" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Toggle filters icon and Export button */}
        <div className="d-flex align-items-center gap-2 mb-2">
          <button
            className="btn btn-sm btn-outline-secondary d-flex align-items-center"
            onClick={exportToCSV}
            title={t('coupons.exportExcel')}
          >
            <Icon.Download size={14} className="mr-2" />
            {t('coupons.exportExcel')}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary d-flex align-items-center"
            onClick={() => setShowFilters(!showFilters)}
            title={t(showFilters ? 'coupons.filters.hide' : 'coupons.filters.show')}
          >
            <Icon.Filter size={14} className="mr-2" /> {t(showFilters ? 'coupons.filters.hide' : 'coupons.filters.show')}
          </button>
        </div>
        {/* Filters Section (compact) */}
        {showFilters && (
        <div className="card mb-3">
          <div className="card-body p-2">
            <div className="row align-items-end">
              <div className="col-md-3">
                <label className="form-label small fw-bold">{t('coupons.filters.campaignLabel')}</label>
                <select
                  className="form-control"
                  value={selectedCampaignFilter}
                  onChange={(e) => setSelectedCampaignFilter(e.target.value)}
                >
                  <option value="all">{t('coupons.filters.campaignAllOption')}</option>
                  {campaigns.map((campaign) => (
                    <option key={campaign.id} value={campaign.id}>
                      {campaign.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small fw-bold">{t('coupons.filters.statusLabel')}</label>
                <select
                  className="form-control"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <option value="all">{t('coupons.filters.statusOptions.all')}</option>
                  <option value="pending">{t('coupons.filters.statusOptions.pending')}</option>
                  <option value="sent">{t('coupons.filters.statusOptions.sent')}</option>
                  <option value="redeemed">{t('coupons.filters.statusOptions.redeemed')}</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small fw-bold">{t('coupons.filters.dateStart')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={dateRange.start}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, start: e.target.value })
                  }
                />
              </div>
              <div className="col-md-2">
                <label className="form-label small fw-bold">{t('coupons.filters.dateEnd')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={dateRange.end}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, end: e.target.value })
                  }
                />
              </div>
            </div>
            {(filterStatus !== "all" || dateRange.start || dateRange.end || selectedCampaignFilter !== "all") && (
              <div className="mt-3">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => {
                    setFilterStatus("all");
                    setDateRange({ start: "", end: "" });
                    setSelectedCampaignFilter("all");
                  }}
                >
                  <Icon.X size={14} className="mr-1" />
                  {t('coupons.filters.clear')}
                </button>
                <span className="ml-3 text-muted">
                  {t('coupons.filters.showing', { count: filteredData?.length || 0, total: statistics.total })}
                </span>
              </div>
            )}
          </div>
        </div>
        )}
        {campaignMeta.id && (
          <div className="mb-3">
            <span className="badge badge-primary mr-2" style={{fontSize: '0.9rem'}}>
              {t('coupons.campaignMeta.idLabel')}: {campaignMeta.id}
            </span>
            {campaignMeta.name && (
              <span className="badge badge-secondary" style={{fontSize: '0.9rem'}}>
                {campaignMeta.name}
              </span>
            )}
          </div>
        )}

        <table className="table table-hover text-left">
          <thead>
            <tr>
              <th scope="col" className="fw-6">
                #
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.creationDate')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.schoolName')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.schoolAddress')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.schoolPhone')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.userName')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.email')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.coupon')}
              </th>
              <th scope="col" className="fw-6">
                {t('coupons.tableHeaders.activationDate')}
              </th>
              <th scope="col" className="fw-6 text-center">
                {t('coupons.tableHeaders.send')}
              </th>
              <th scope="col" className="fw-6 text-center">
                {t('coupons.tableHeaders.remove')}
              </th>
            </tr>
          </thead>
          <tbody>
            {displayedData && displayedData.length > 0 ? (
              displayedData.map((school, idx) => {
                const d = new Date(school.createdAt);
                const actived = new Date(school.activatedAt);
                return (
                  <tr key={startIndex + idx}>
                    <th scope="row" className="fw-6">
                      {startIndex + idx + 1}
                    </th>
                    <td>{d.toDateString()}</td>
                    <td className="longLine mw-200">{school.SchoolName}</td>
                    <td
                      className="longLine mw-100 pt-cur"
                      title={school.SchoolAddress}
                    >
                      {school.SchoolAddress ? (
                        <span
                          className="copy-btn"
                          onClick={(event) => {
                            event.preventDefault();
                            navigator.clipboard.writeText(school.SchoolAddress);
                            setMsgData(
                              {
                                message: t('coupons.copy.success'),
                                type: "Success",
                              } || null
                            );
                          }}
                        >
                          <Icon.Copy size="16" className="mr-2 text-primary" />
                          {school.SchoolAddress}
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td className="longLine mw-100">{school.OfficePhone}</td>
                    <td>{school.UserName}</td>
                    <td className="longLine mw-200">
                      <a href={"mailto:" + school.Email} className="text-muted">
                        {school.Email}
                      </a>
                    </td>
                    <td>
                      {school.Coupon ? (
                        school.redeem ? (
                          <span className="text-success">{school.Coupon}</span>
                        ) : (
                          <span className="text-danger">{school.Coupon}</span>
                        )
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{school.activatedAt ? actived.toDateString() : ""}</td>
                    <td>
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          document.getElementById("send-coupon").click();
                          setSchool(school);
                          // if (
                          //   window.confirm(
                          //     "Do you really wants to resend the coupon?"
                          //   )
                          // ) {
                          //   sendCoupon(school.Email);
                          // }
                        }}
                        className={
                          school.Coupon
                            ? "c-ptr d-flex align-items-center justify-content-center text-success"
                            : "c-ptr d-flex align-items-center justify-content-center"
                        }
                      >
                        <Icon.Send
                          size="18"
                          strokeWidth="1.5"
                          className="mr-2"
                        />
                        {school.Coupon ? t('coupons.actions.resend') : t('coupons.actions.send')}
                      </a>
                    </td>
                    <td>
                      {!school.redeem ? (
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            if (
                              window.confirm(
                                t('coupons.remove.confirm')
                              )
                            ) {
                              axios
                                .delete(
                                  `${url}/api/admin/delete-coupon-user/${school.Email}`,
                                  {
                                    headers: getAuthHeaders(),
                                  }
                                )
                                .then((res) => {
                                  setMsgData(
                                    {
                                      message: res.data.message,
                                      type: res.data.status,
                                    } || null
                                  );
                                })
                                .catch((err) => {
                                  console.log(err, err.response);
                                  if (err?.response?.status === 401) {
                                    sessionStorage.clear();
                                    history.push("/");
                                    return;
                                  }
                                  setMsgData(
                                    {
                                      message: err.response?.data?.message,
                                      type: err.response?.status,
                                    } || null
                                  );
                                });
                            }
                          }}
                          className="c-ptr d-flex align-items-center justify-content-center text-danger"
                        >
                          <Icon.Delete
                            size="18"
                            strokeWidth="1.5"
                            className="mr-2"
                          />
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="11" className="text-center py-5">
                  <Icon.Inbox size={48} className="text-muted mb-3" />
                  <p className="text-muted">{t('coupons.empty.filters')}</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* Pagination controls */}
        <div className="d-flex justify-content-between align-items-center my-3">
          <div>
            <span className="mr-2">{t('coupons.pagination.itemsPerPage')}</span>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(parseInt(e.target.value, 10));
                setPage(1);
              }}
              className="form-control d-inline-block"
              style={{ width: 90 }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <span className="ml-3 text-muted">
              {t('coupons.pagination.range', { start: startIndex + 1, end: Math.min(endIndex, totalItems), total: totalItems })}
            </span>
          </div>
          <div>
            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setPage(Math.max(1, page - 1))}>{t('coupons.pagination.prev')}</button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">{t('coupons.pagination.pageOf', { page, pages: totalPages })}</span>
                </li>
                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setPage(Math.min(totalPages, page + 1))}>{t('coupons.pagination.next')}</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div
          className="modal fade"
          id="addModel"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="addCoupon"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content text-left">
              <div className="modal-header">
                <h5 className="modal-title" id="addCoupon">
                  {t('coupons.addModal.title')}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={(e) => addCouponHandler(e)} method="POST">
                <div className="modal-body">
                  <div className="form-group">
                    <label htmlFor="school-name" className="col-form-label">
                      {t('coupons.addModal.schoolName')}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="school-name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="school-address" className="col-form-label">
                      {t('coupons.addModal.schoolAddress')}
                    </label>
                    <textarea
                      className="form-control"
                      id="school-address"
                      required
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label htmlFor="school-phone" className="col-form-label">
                      {t('coupons.addModal.schoolPhone')}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="school-phone"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="user-name" className="col-form-label">
                      {t('coupons.addModal.userName')}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="user-name"
                      required
                    />
                  </div>
                  <div className="form-group row">
                    <div className="col-md-8">
                      <label htmlFor="school-email" className="col-form-label">
                        {t('coupons.addModal.email')}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="school-email"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="provider" className="col-form-label">
                        {t('coupons.addModal.provider')}
                      </label>
                      <select
                        className="form-control"
                        id="provider"
                        name="provider"
                      >
                        <option value="microsoft">{t('coupons.addModal.providers.microsoft')}</option>
                        <option value="google">{t('coupons.addModal.providers.google')}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="cancel"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    {t('coupons.addModal.close')}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {t('coupons.addModal.save')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#exampleModal"
          id="send-coupon"
          style={{ display: "none" }}
        >
          sendCoupon
        </button>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {school.Coupon ? t('coupons.sendModal.titleResend') : t('coupons.sendModal.titleSend')}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: "left" }}>
                {school.Coupon ? t('coupons.sendModal.messageResend') : t('coupons.sendModal.messageSend')}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  id="close"
                >
                  {t('coupons.sendModal.close')}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ backgroundColor: "#D3313A", borderColor: "#D3313A" }}
                  onClick={() => sendCoupon(school.Email, school.UserName)}
                >
                  {school.Coupon ? t('coupons.actions.resend') : t('coupons.actions.send')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coupons;
